export class ShaderVariable {
    constructor() {
        this.onID = ShaderVariable.pointID++;
        this.textureID = -1;
    }
}
ShaderVariable.pointID = 0;
